import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const ReferRestaurant = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    franchise_name: "",
    district: "",
    area: "",
    state: "",
    pincode: "",
    information: "",
    type: [],
    owner_name: "",
    owner_mobile: "",
    google_map_link: "",
  });

  const [loading, setLoading] = useState(false);

  const Base_Url = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, mobile: value }));
  };

  const handleOwnerMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, owner_mobile: value }));
  };

  const handleTypeChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];
    setFormData({ ...formData, type: values });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.type.length) {
      Swal.fire({
        icon: "warning",
        title: "Select restaurant type",
        text: "Please select at least one restaurant type.",
      });
      return;
    }

    setLoading(true);

    try {
      const apiData = {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        franchise_name: formData.franchise_name,
        type: formData.type, // ARRAY (Laravel-friendly)
        district: formData.district,
        area: formData.area,
        state: formData.state,
        pincode: formData.pincode,
        information: formData.information,
        owner_name: formData.owner_name || null,
        owner_mobile: formData.owner_mobile || null,
        google_map_link: formData.google_map_link || null,
      };

      const response = await axios.post(`${Base_Url}referFranchise`, apiData);

      if (response.data) {
        await Swal.fire({
          icon: "success",
          title: "Thank you for the referral!",
          html: `
            <p style="text-align:center">
              We’ve received your restaurant suggestion.<br/><br/>
              Our team will review and contact them shortly.<br/><br/>
              <strong>If the restaurant joins MyFoodMyPrice,<br/>
              you’ll be notified and rewarded.</strong>
            </p>
          `,
          confirmButtonText: "Submit another referral",
          confirmButtonColor: "#f97316",
          allowOutsideClick: false,
        });

        setFormData({
          name: "",
          email: "",
          mobile: "",
          franchise_name: "",
          district: "",
          area: "",
          state: "",
          pincode: "",
          information: "",
          type: [],
          owner_name: "",
          owner_mobile: "",
          google_map_link: "",
        });
      }
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      console.log("API Error:", status, data);

      if (status === 409) {
        Swal.fire({
          icon: "info",
          title: "Already Referred",
          text: data?.message,
        });
        return;
      }

      if (status === 422 && data?.errors) {
        const errorList = Object.values(data.errors)
          .flat()
          .map((msg) => `<li>${msg}</li>`)
          .join("");

        Swal.fire({
          icon: "error",
          title: "Validation Error",
          html: `<ul style="text-align:left">${errorList}</ul>`,
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: data?.message || "Something went wrong. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  const restaurantTypes = [
    { value: "restaurant", label: "Restaurant" },
    { value: "cloudkitchen", label: "Cloud Kitchen" },
    { value: "homechef", label: "Home Chef" },
    { value: "caterer", label: "Caterer" },
    { value: "cafe", label: "Cafe" },
    { value: "baker", label: "Baker" },
    { value: "Dont Know", label: "Don't Know" },
  ];

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="restaurant-modal">
        <button
          type="button"
          className="btn-close btn-close-white float-end"
          aria-label="Close"
          onClick={onHide}
        />

        <h3 className="contact-form-banner mb-2 text-center">
          Refer Your Favourite
        </h3>
        <h3 className="contact-form-banner mb-2 text-center">
          Restaurant/Cloud Kitchen/Home Chef Now!
        </h3>

        <h6 className="restaurant-h6-info text-center mb-3">
          Please fill your favourite restaurant details.
        </h6>

        <form onSubmit={handleSubmit}>
          {/* Name & Mobile */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="mobile"
                className="form-control"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleMobileChange}
                maxLength={10}
                pattern="[0-9]{10}"
                inputMode="numeric"
                required
              />
            </div>
          </div>

          {/* Email */}
          <div className="mb-3">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Restaurant Name & Type */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="franchise_name"
                className="form-control"
                placeholder="Restaurant / Outlet Name"
                value={formData.franchise_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <Select
                isMulti
                options={restaurantTypes}
                name="type"
                classNamePrefix="select"
                placeholder="Select Type"
                value={restaurantTypes.filter((option) =>
                  formData.type.includes(option.value),
                )}
                onChange={handleTypeChange}
              />
            </div>
          </div>

          {/* Area & District */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="area"
                className="form-control"
                placeholder="Area / Locality"
                value={formData.area}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="district"
                className="form-control"
                placeholder="District"
                value={formData.district}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* State & Pincode */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="state"
                className="form-control"
                placeholder="State"
                value={formData.state}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="pincode"
                className="form-control"
                placeholder="Pincode"
                value={formData.pincode}
                onChange={handleChange}
                required
                maxLength={6}
                pattern="[0-9]{6}"
                inputMode="numeric"
              />
            </div>
          </div>

          {/* Owner Details */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="owner_name"
                className="form-control"
                placeholder="Owner / Manager Name (Optional)"
                value={formData.owner_name}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="owner_mobile"
                className="form-control"
                placeholder="Owner Mobile"
                value={formData.owner_mobile}
                onChange={handleOwnerMobileChange}
                maxLength={10}
                pattern="[0-9]{10}"
                inputMode="numeric"
              />
            </div>
          </div>

          {/* Google Map Link */}
          <div className="mb-3">
            <input
              type="url"
              name="google_map_link"
              className="form-control"
              placeholder="Google Map Link"
              value={formData.google_map_link}
              onChange={handleChange}
            />
          </div>

          {/* Additional Info */}
          <div className="mb-4">
            <textarea
              name="information"
              className="form-control"
              placeholder="Any additional information about the restaurant..."
              rows="3"
              value={formData.information}
              onChange={handleChange}
            />
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Registration"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ReferRestaurant;
